module.exports = __webpack_public_path__ + "static/media/32_A.3e39e74d.png";